export default "__VITE_ASSET__e989931c__"